module.exports = __webpack_public_path__ + "static/media/country_ly.1c30c41a.webp";